import {
  PAYROLL_LOADING,
  GET_PAYROLL,
  GET_PAYROLL_SUCCESS,
  GET_PAYROLL_FAIL,
  ADD_PAYROLL_SUCCESS,
  ADD_PAYROLL_FAIL,
  DELETE_PAYROLL_SUCCESS,
  DELETE_PAYROLL_FAIL,
  UPDATE_PAYROLL_SUCCESS,
  UPDATE_PAYROLL_FAIL
} from "./actionType";

const INIT_STATE = {
  payrolls: [],
  error: {},
};

const Payroll = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PAYROLL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PAYROLL:
          return {
            ...state,
            payrolls: action.payload.data,
            isPayrollCreated: false,
            isPayrollSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PAYROLL_FAIL:
      switch (action.payload.actionType) {
        case GET_PAYROLL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPayrollCreated: false,
            isPayrollSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PAYROLL: {
      return {
        ...state,
        isPayrollCreated: false,
        loading: true,
      };
    }

    case PAYROLL_LOADING: {
      return {
        ...state,
        isPayrollCreated: false,
        loading: true,
      };
    }

    case ADD_PAYROLL_SUCCESS:
      return {
        ...state,
        isPayrollCreated: true,
        loading: false,
        payrolls: [action.payload.data, ...state.payrolls],
      };

    case ADD_PAYROLL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PAYROLL_SUCCESS:
      return {
        ...state,
        loading: false,
        payrolls: state.payrolls.filter(
          payroll => payroll.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PAYROLL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PAYROLL_SUCCESS:
      return {
        ...state,
        loading: false,
        payrolls: state.payrolls.map(payroll =>
          payroll.id.toString() === action.payload.data.id.toString() ? { ...payroll, ...action.payload.data } : payroll
        ),
      };

    case UPDATE_PAYROLL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return { ...state };
  }
};

export default Payroll;